import AvatarIcon from 'assets/icon/AvatarIcon'
import MenuIcon from 'assets/icon/MenuIcon'
import LogoutButton from 'components/Button/LogoutButton'
import Dropdown from 'components/Input/Dropdown'
import { useEffect, useState, useContext } from 'react'
import { useAuth } from 'utils/context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { useVariable } from 'utils/context/VariableContext'

function Navbar({ toggleSidebar }) {
	let pathArray = window.location.pathname.split("/")

	const navigate = useNavigate()

	const { logout } = useAuth()
	const { locationOptions, locationId, locationName, name, setVariableLocationId, setVariableLocationName } = useVariable()

	const selectedLocationChange = (option) => {
		setVariableLocationName(option.label)
		setVariableLocationId(option.value)
	}

	function fLogoutBtnClick(){
		logout() 

		navigate("/login")
	}

	useEffect(() => {
		if (locationOptions.length === 1) {
			setVariableLocationId(locationOptions[0].value)
		} else if (locationOptions.length > 1) {
			if ((locationId === "") && locationOptions.length > 0) {
				setVariableLocationId(locationOptions[0].value)
			}
		} else {
			setVariableLocationId('')
		}
	}, [])

   	return (
		<div className={`sticky top-0 bg-white transition-all z-20 w-full flex justify-between items-center py-2 px-4 h-14`}>
			<div className='flex items-center gap-4'>
				<button className='block' onClick={toggleSidebar}>
					<MenuIcon className='fill-black w-5' />
				</button>
				<span className='text-lg font-semibold hidden md:block'>Yupiter Finance</span>
			</div>
			<div className='flex gap-3 justify-between items-center'>
				<div className='bg-black px-4 py-1 rounded-full items-center hidden md:flex'>
					<h1 className='pl-12 sm:pl-0 text-white'>Welcome back, { name }</h1>
				</div>

				<div className='flex gap-2 items-center'>
					<span className='hidden sm:block'>Location : </span>

					{locationOptions.length <= 1 &&
						<span>{locationOptions.length === 1 ? locationOptions[0].label : "N/A"}</span>
					}
					{locationOptions.length > 1 && (
						<Dropdown className='w-64 ' options={locationOptions} value={locationId} onChange={selectedLocationChange} />
					)}
				</div>
				
				<div className="relative flex items-center justify-center">
					<LogoutButton onClick={() => { fLogoutBtnClick() }} />
				</div>
			</div>
		</div>
	)
}

export default Navbar